import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("courierToken");

  if (!token) {
    return <Navigate to="/courierLogin" replace />;
  }

  return children;
}